import React from 'react'
import icon1 from '../../../../assets/images/projectHighlights/icon1.svg';
import icon2 from '../../../../assets/images/projectHighlights/icon2.svg';
import icon3 from '../../../../assets/images/projectHighlights/icon3.svg';
import icon4 from '../../../../assets/images/projectHighlights/icon4.svg';
import './Capabilites.css'

const Capabilites = () => {
  return (
    <div id="capabilities" className='capabilities'>
    <div className="project-bottom">

          <h2 className="cap-title-man">Our Manufacturing Capabilities</h2>

        <div className="cap-grid">

            <div className="cap-card">
              <div className='cap-card-top'>
                <h3>Sterile Injectables</h3>
                <div className='iconwrapperph'>
                  <img src={icon1} alt="" />
                </div>
              </div>
              <p>Small volume parenteral injectable production.</p>
            </div>

            <div className="cap-card">
              <div className='cap-card-top'>
                <h3>Oral Solid Dosage</h3>
                <div className='iconwrapperph'>
                  <img src={icon2} alt="" />
                </div>
              </div>
              <p>High-capacity tablet and capsule manufacturing.</p>
            </div>

            <div className="cap-card">
              <div className='cap-card-top'>
                <h3>Oral Liquid Formulations</h3>
                <div className='iconwrapperph'>
                  <img src={icon3} alt="" />
                </div>
              </div>
              <p>Syrups, suspensions, and oral solutions.</p>
            </div>

            <div className="cap-card">
              <div className='cap-card-top'>
                <h3>Biologic Production</h3>
                <div className='iconwrapperph'>
                  <img src={icon4} alt="" />
                </div>
              </div>
              <p>Advanced biosimilar and recombinant product manufacturing.</p>
            </div>

          </div>

        </div>
    </div>
  )
}

export default Capabilites